import TrafficOverallChangeMetric from "app/pages/sales-intelligence/sub-modules/signals/models/traffic/TrafficOverallChangeMetric";
import TrafficSourceTypeMetric from "app/pages/sales-intelligence/sub-modules/signals/models/traffic/TrafficSourceTypeMetric";
import TrafficEngagementMetric from "app/pages/sales-intelligence/sub-modules/signals/models/traffic/TrafficEngagementMetric";

export const ORDERED_TRAFFIC_OVERALL_CHANGE_METRICS: readonly TrafficOverallChangeMetric[] = [
    TrafficOverallChangeMetric.MonthlyVisits,
    TrafficOverallChangeMetric.TotalPageViews,
    TrafficOverallChangeMetric.UniqueMonthlyVisitors,
];

export const ORDERED_TRAFFIC_SOURCE_TYPE_METRICS: readonly TrafficSourceTypeMetric[] = [
    TrafficSourceTypeMetric.SearchVisits,
    TrafficSourceTypeMetric.PaidSearchVisits,
    TrafficSourceTypeMetric.OrganicSearchVisits,
    TrafficSourceTypeMetric.DirectVisits,
    TrafficSourceTypeMetric.SocialVisits,
    TrafficSourceTypeMetric.OrganicSocialVisits,
    TrafficSourceTypeMetric.PaidSocialVisits,
    TrafficSourceTypeMetric.ReferralsVisits,
    TrafficSourceTypeMetric.DisplayAdsVisits,
    TrafficSourceTypeMetric.MailVisits,
    TrafficSourceTypeMetric.GenAiVisits,
    TrafficSourceTypeMetric.AffiliateVisits,
];

export const NEW_TRAFFIC_SOURCE_TYPE_METRICS: ReadonlySet<TrafficSourceTypeMetric> = new Set([
    TrafficSourceTypeMetric.SearchVisits,
    TrafficSourceTypeMetric.OrganicSocialVisits,
    TrafficSourceTypeMetric.PaidSocialVisits,
    TrafficSourceTypeMetric.GenAiVisits,
    TrafficSourceTypeMetric.AffiliateVisits,
]);

export const ORDERED_TRAFFIC_ENGAGEMENT_METRICS: readonly TrafficEngagementMetric[] = [
    TrafficEngagementMetric.TotalBounceRate,
    TrafficEngagementMetric.TotalPagesPerVisit,
    TrafficEngagementMetric.TotalAvgVisitDuration,
    TrafficEngagementMetric.TotalMonthlyVisitsPerVisitor,
];
